<template>
  <div id="login">
    <div class="LoginTitle">
      <div class="Title-1">你好，欢迎使用</div>
      <div class="Title-2">智慧笔记</div>
    </div>
    <van-cell-group>
      <van-field
        v-model="username"

        name="username"
        clearable
        placeholder="请输入手机号码"
        style="margin-bottom:10vw"
      />
      <van-field
        v-model="password"
        :type="pwdType"
        class="PassWord"
        :right-icon="quest"
        placeholder="请输入密码"
        style="margin-bottom:8vw"
        @click-right-icon="change()"
      />
    </van-cell-group>
    <!-- <div class="checked">
      <van-checkbox v-model="checked" checked-color="#07c160" @click="pwdcheck"></van-checkbox>
      <span>是否记住密码</span>
    </div> -->

    <van-button
      class="logins"
      :class="password!=''&&username!=''?'btnColor':''"
      @click="logins()"
    >登录</van-button>
    <div class="dangerTitle">
      <span class="dangerTitle-1">登录即表示你已阅读并同意</span>
      <span class="dangerTitle-2" @click="agreement">《用户协议》</span>
      <!-- <span class="dangerTitle-2">《隐私协议》</span> -->
    </div>
  </div>
</template>

<script>
import { button, Field, Icon, Cell, Toast, CellGroup, Popup } from "vant";
import { login } from "@/api/login.js";
import { jpush } from "@/utils/jpush";
export default {
  components: {
    [button.name]: button,
    [Field.name]: Field,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
  },
  data() {
    return {
      quest: "closed-eye",
      checked: false,
      username: "",
      password: "",
      pwdType: "password",
    };
  },
  mounted() {
	  if(!this.isMOBILE()){
		  this.$router.push({
			  path:'/PCLogin'
		  })
	  }
    if (localStorage.getItem("userName")&&localStorage.getItem("userName") != "") {
      this.username = localStorage.getItem("userName");
    }
    if (localStorage.getItem("password")&&localStorage.getItem("password") != "") {
      this.password = localStorage.getItem("password");
      this.checked = true;
    }
  },
  methods: {
    change() {
      this.quest = this.quest === "closed-eye" ? "eye-o" : "closed-eye";
      this.pwdType = this.pwdType === "password" ? "text" : "password";
    },
    logins() {
      if (this.username === "") {
        this.$toast("用户名不能为空");
        return false;
      }
      if (this.password === "") {
        this.$toast("密码不能为空");
        return false;
      }
      localStorage.setItem("userName", this.username);
      if (this.checked) {
        localStorage.setItem("password", this.password);
      } else {
        localStorage.removeItem("password");
      }
      login({
        username: this.username,
        password: this.password,
      }).then((res) => {
        if (res.code === 0) {
          const data = JSON.stringify(res.user.user);
          localStorage.setItem("user", data);
          // 单独存储token
          localStorage.setItem("Token", res.user.user.token);
          // this.jpushHandel();
          this.$router.push("home");
        } else {
          this.$toast(res.msg);
        }
      });
    },
    // 设备号绑定
    async jpushHandel() {
      await jpush();
    },
    agreement() {
      this.$router.push("userAfreement");
    },
    pwdcheck() {
      console.log(this.checked);
    },
	  isMOBILE () {
		  let flag = navigator.userAgent.match(
			  /(phone|pad|pod|iphone|ipod|ios|iPad|Android|Mobild|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|webOS|Symbian|Windows Phone)/i
		  )
		  return flag
	  }
  },
};
</script>
<style lang="less" scoped>
#pdfs {
  width: 220vw;
}
#login {
  height: 100%;
  background-color: #fff;
  .LoginTitle {
    margin: 31vw 0 20vw 0;
    padding-left: 8.9vw;
    font-size: 7.4vw;
    font-family: SourceHanSansCN-Bold;
    font-weight: 600;
    .Title-1 {
      margin-top: 2.87vw;
      color: #6d7277;
    }
    .Title-2 {
      margin-top: 2.87vw;
      color: #1ec78d;
    }
  }
  .logins {
    width: 80vw;
    height: 12vw;
    line-height: 12vw;
    border-radius: 3vw;
    display: block;
    background-color: #d3d8dc;
    margin: 0 auto;
    color: #fff;
    font-size: 5vw;
    letter-spacing: 0;
    margin-top: 15vw;
  }
  .btnColor {
    background-color: #1ec78d;
  }
  .Phone {
    font-size: 4.85vw !important;
    input {
      font-size: 20px !important;
    }
  }
  .PassWord {
    font-size: 4.85vw !important;
    //  background-color: red;
    input {
      font-size: 20px !important;
    }
  }
  .van-field__left-icon {
    margin-right: 3vw;
  }
  .van-cell {
    padding: 0 10vw;
  }
  .van-cell:not(:last-child)::after {
    border-bottom: 1px solid #dbdbdb;
    left: 10vw;
    right: 10vw;
  }
  .van-cell:last-child::after {
    border-bottom: 1px solid #dbdbdb !important;
  }
  .van-checkbox__label {
    color: #c2c2c2;
    font-size: 4vw;
  }
  .van-checkbox {
    margin-left: 10vw;
  }
  .eye {
    width: 4vw;
    height: 3vw;
  }
  .lock {
    width: 4vw;
    height: 5vw;
    padding-left: 10vw;
    position: relative;
    top: -14vw;
    margin-bottom: 0;
  }
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: 0;
  }
}
.dangerTitle {
  margin-top: 33.5vw;
  margin-left: 12.5vw;
  .dangerTitle-1 {
    color: #d3d8dc;
  }
  .dangerTitle-2 {
    color: #25c991;
  }
}
.checked {
  // background-color: pink;
  display: flex;
  span {
    margin-left: 3vw;
    font-size: 4vw;
    color: #999;
  }
}
</style>
